import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router";
import { AppBoundary } from "./app/Crash";
import { loadConfig } from "./config";
import { loadPlatform } from "./platform";
import { routes } from "./routes";
import { initSentry } from "./sentry";
import "./index.css";

const config = await loadConfig();
initSentry(config);
// The browser, the desktop app or the mobile apps. Falls back to the browser if a shell fails to start.
await loadPlatform().catch((err) => console.error("Rhema could not start the native shell", err));

const router = createBrowserRouter(routes);

// The service worker shows push notifications and receives shares. It does not cache the app. Registering it asks
// for nothing; permission is requested later, after the person chooses to turn notifications on.
if ("serviceWorker" in navigator && import.meta.env.PROD) {
  void navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch(() => undefined);
}

const root = document.getElementById("root");
if (root) {
  createRoot(root).render(
    <StrictMode>
      <AppBoundary>
        <RouterProvider router={router} />
      </AppBoundary>
    </StrictMode>,
  );
}
